import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@veycue/ui/tokens.css";
import "./styles.css";
import { App } from "./App";

const container = document.getElementById("root");
if (!container) throw new Error("Brak elementu #root");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
